import { render, staticRenderFns } from "./StudyPlansTableTermsHeader.vue?vue&type=template&id=09c54e70&"
import script from "./StudyPlansTableTermsHeader.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTableTermsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports